<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4chap1#chap1">Introduction to Standard Dreaming</a></p>
<p class="toc1"><a href="#/5chap2#chap2">Standard Dreaming</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/7about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?d8804722